import { useEffect } from "react";
import { ListSkeleton } from "../../skeletons/List";
import { useState } from "react";
import {  Container, Typography, Box, Tab, Tabs } from "@mui/material";
import { useDashboardDrawer } from "../../providers/consumers/useDashboardDrawer";
import { useBuilder } from "../../../hooks/useBuilder";
import store, { clear, setFieldState } from "../../store/formStore";
import { useSelector } from "react-redux";

import DataTable from "../../components/Table";
import moment from "moment";
import { AuthHelper } from "../../controllers/AuthHelper";
import { ServerConfig } from "../../../connectors/Config";


function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
const ListPrenotazioni = () => {
    const [certificates, setCertificates] = useState([]);
    const [loading, setLoading] = useState(false);
    const { pushMobileOpen, defaultOpen, addRouter } = useDashboardDrawer();
    const {builder, form, refs} = useBuilder();
    const [value, setValue] = useState(0);
    const [prenotazioni, setPrenotazioni] = useState([]);

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const findPrenotazioni = async() => {
      let user = await AuthHelper.getUserFromIdToken();

      const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/prenotations/${user.Username}`);
      const json = await res.json();
      
      setPrenotazioni([...json]);
    }
    const elements = useSelector(state => state.elements);

    const columns = [
        { field: 'id', headerName: 'ID', width: 125, headerClassName: 'data-grid-header'},
        { field: 'fiscal_code', headerName: 'Codice Fiscale', width: 200, headerClassName: 'data-grid-header'},
        { field: 'nome corso', headerName: 'Corso', width: 200, headerClassName: 'data-grid-header' },
        { field: 'data_pagamento', headerName: 'Data pagamento', width: 200, headerClassName: 'data-grid-header',valueGetter: (value) => moment(value).format('DD/MM/YYYY') },
        { field: 'payment', headerName: 'ID Pagamento', width: 250, headerClassName: 'data-grid-header'}

    ];

    const getCertificates = async() => {
       
    }
    useEffect(() => {
        findPrenotazioni();
        store.dispatch(clear())
        builder('promo.add');
    }, [])

    const handleClick = (data, name = null) => {
        store.dispatch(clear())
        builder('promo.add');
        if(data.row){
            Object.keys(data.row).forEach((key) => {
                store.dispatch(setFieldState({name: key, value: data.row[key]}));
            });
        }
        pushMobileOpen(true, 500, name ? name : "Modifica Corso", data.row);

    }

    return (<Container sx={{paddingLeft: 24, paddingRight: 24, minWidth: '100vw', marginTop: '3rem'}}>
    
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Lista prenotazioni" {...a11yProps(0)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        {loading && <ListSkeleton />}
        {/* {!loading && <DataTable data={certificates} columns={columns} handleClick={handleClick} actions={[
            {type: 'select', name: 'Azioni'}
        ]}/>} */}
        {!loading && <DataTable data={[...new Set(prenotazioni)]} columns={columns} handleClick={handleClick} actions={[
        {type: 'select', name: 'Azioni'}
        ]}/>}
      </CustomTabPanel>
   
    
    </Container>);
}

export default ListPrenotazioni;